<script setup>
import {computed} from 'vue'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    name: String,
    placementRight: Boolean
})

const appStore = useAppStore()

const open = computed(() => !!appStore.sidebarToggle?.[props.name])

const toggle = () => {
    appStore.toggleSidebar(props.name)
}

if (appStore.sidebarToggle[props.name] === undefined) {
    appStore.setSidebarToggle({name: props.name, value: true})
}
</script>

<template>
    <div :class="{'sidebar-toggle-hidden': !open, 'end-0 border-end ': !placementRight, 'border-start': placementRight}"
         class="h-100 px-1 position-absolute top-0" role="button" @click="toggle"/>
</template>

<style scoped>
[data-bs-theme="dark"] .border-end:hover,
[data-bs-theme="dark"] .border-start:hover,
[data-bs-theme="light"] .border-end:hover,
[data-bs-theme="light"] .border-start:hover {
    border-color: var(--bs-secondary-color) !important;
}

.border-end.sidebar-toggle-hidden,
.border-start.sidebar-toggle-hidden {
    border-left-width: 5px;
}
</style>